import React from 'react'
import { useSearchParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '../ui/button';

interface TabLayoutProps {
    children?: React.ReactNode;
    title?: string;
}

function PageLayout({ children, title }: TabLayoutProps) {
  const [params] = useSearchParams();
  const subTitle = params.get('ref') ?? '';

  return (
    <div className="flex flex-col border border-gray-200 h-full">
        {title && (
            <div className="flex items-center gap-2 px-4 py-2 border-b border-gray-200 text-gray-500">
                <Button variant="ghost" className="p-1" onClick={() => window.history.back()}>
                    <ChevronLeft className="cursor-pointer" />
                </Button>
                <span>{title}</span> {'-'}
                <span className="text-blue-500 font-bold">{subTitle}</span>
            </div>
        )}
        <div className="flex-1 overflow-y-auto bg-white">
            {children}
        </div>
    </div>
  )
}

export default PageLayout;